module.exports = __webpack_public_path__ + "6033b87afc3edcd65d029eb8fdc10665.svg";